import * as React from 'react';
import classnames from 'classnames';
import { Button } from 'reactstrap';

import './popupView.scss';

interface IButton {
  text: string;
  color: string;
  type?: string;
  onClick: () => void;
}

interface IProps {
  title?: string;
  info?: string;
  buttons?: IButton[];
  buttonLayout?: 'horizontal' | 'vertical';
  icon?: string;
}

const PopupView = ({ title, info, buttons, buttonLayout, icon }: IProps) => {
  const cancelButton = buttons && buttons.find(item => item.type === 'cancel');

  return (
    <div className={'popup-container'}>
      <div className={'popup-inner-container'}>
        {cancelButton && (
          <i
            className="icon-cross"
            color="primary"
            onClick={() => cancelButton.onClick()}
          />
        )}
        {icon && <i className={classnames('popup-icon', icon)} />}
        <p className={'popup-header'}>{title}</p>
        <p className={'popup-info'}>{info}</p>

        <div
          className={classnames(
            'popup-buttons-container',
            buttonLayout || 'horizontal'
          )}
        >
          {buttons &&
            buttons.map((item, index) => (
              <Button
                className={'popup-button'}
                key={index}
                color={item.color}
                onClick={() => item.onClick()}
              >
                {item.text}
              </Button>
            ))}
        </div>
      </div>
    </div>
  );
};

export default PopupView;
